import Image from 'next/image';
import styled from 'styled-components';
import { FlexColumn, FlexibleDiv } from '../../../styled/common';
import { Typography } from '../../ui/Typography';
import { tagStyles } from '../../ui/Typography/styles';
import { Breakpoints } from '../../../styled/constants';

export const AgencyHeaderContainer = styled.div`
  padding-bottom: 20px;
  border-bottom: 0.5px solid ${({ theme }) => theme.colors.border.primary};

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    border-bottom: none;
    padding: 0;
  }
`;

export const AgencyHead = styled(FlexibleDiv)`
  gap: 15px;
  align-items: center;
  margin-bottom: 20px;
`;

export const AgencyHeaderLogo = styled(Image)`
  width: 80px;
  height: 80px;
  border-radius: 7px;
  flex: 0 0 auto;
`;

export const AgencyHeaderInfo = styled(FlexColumn)`
  gap: 5px;
`;

export const AgencyTitle = styled(Typography)`
  margin: 0;
  ${tagStyles.h5_new};
`;

export const InfoViewContainer = styled(FlexColumn)`
  gap: 2px;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    flex-direction: row;
    gap: 0;
  }
`;

export const AgencyInfoViews = styled(Typography)`
  display: block;
  color: ${({ theme }) => theme.colors.text.secondary};

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    &:not(:first-of-type)::before {
      content: '';
      display: inline-block;
      width: 3px;
      height: 3px;
      background: ${({ theme }) => theme.colors.text.secondary};
      border-radius: 50%;
      margin: 0 10px;
      position: relative;
      bottom: 3px;
    }
  }
`;
